import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { CSVLink } from 'react-csv'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import { generateStudentListCsvData } from './utils'

const ExportStudentListDialog = ({ open, onClose, students }) => {
  const classes = useDialogTitleStyles()

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Export student list
            </Typography>
            <Typography className={classes.bodyText}>
              Export your full student list as a CSV file. Click Download to
              save it to your device.
            </Typography>
          </DialogTitle>
          <DialogActions className={classes.actions}>
            <Button onClick={closeDialog} color="primary">
              Cancel
            </Button>
            <Button
              component={CSVLink}
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              filename="student_list.csv"
              data={generateStudentListCsvData(students)}
              onClick={closeDialog}
            >
              Download
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

ExportStudentListDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  students: PropTypes.array,
}

export default ExportStudentListDialog
